<template>
    <alert-modal
        :title="$t('START_OVER')"
        :primaryCTAText="$t('ACTION_START_OVER')"
        :secondaryCTAText="$t('ACTION_CONTINUE_SESSION')"
        :blue="true"
        @close="close"
        @cancel="close"
        @confirm="resetSession"
        @overlayClick="close"
    >
        <div class="cz2__modal-popup__content cz2__modal-popup__content-kiosk-restart">
            {{$t('START_OVER_MESSAGE')}}
        </div>
    </alert-modal>
</template>

<style lang="scss">
    @import '../style/variables';

    #cz2.cz2.cz2__is-kiosk {
        .cz2__modal-popup__content-kiosk-restart {
            padding-bottom: 32px;
        }
    }
</style>

<script>
    import AlertModal from './ui/AlertModal.vue';

    export default {
        components: {
            AlertModal,
        },

        methods: {
            close() {
                this.$store.dispatch('showKioskRestartWarning', false);
            },

            resetSession() {
                this.$store.dispatch('showKioskRestartWarning', false);
                window.location.reload();
            },
        },
    };
</script>
